export default __webpack_public_path__ + "static/promo-card-live-weekly-demo-dee18f485f9e9901d8dd3a355326df0d.png";